import { Descriptions } from "antd";
import React from "react";
import { useSearchParam } from "react-use";
import { get } from "lodash";

const Sales = ({ occurrence }) => {
	const isProgram = useSearchParam("isProgram") === "true";
	const fee = parseFloat(
		get(occurrence, isProgram ? "Occasion.fee" : "Category.fee", "0"),
	);

	if (!fee) {
		return null;
	}

	return (
		<Descriptions
			bordered
			column={1}
			className="pt-2"
			labelStyle={{
				width: "calc(100%/3)",
				padding: "8px 28px",
			}}
			contentStyle={{
				textAlign: "right",
				padding: "8px 28px",
			}}
			items={[
				{
					label: "料金",
					children: fee.toLocaleString("en-US"),
					contentStyle: {
						fontSize: 14,
					},
				},
				{
					label: "売上",
					children: occurrence?.registrations
						?.filter(({ attended }) => attended)
						.reduce(
							(prev, { paymentAmount }) => prev + parseFloat(paymentAmount),
							0,
						),
					contentStyle: {
						fontSize: 20,
						lineHeight: 1,
						fontWeight: 700,
					},
				},
			]}
		/>
	);
};

export default Sales;
